module.exports = __webpack_public_path__ + "static/media/house-leave.d90b4036.svg";